// src/Services/axiosInstances.js
import axios from "axios";

/* ================= BASE URLS ================= */
const BASE_URL_MASTER = process.env.REACT_APP_API_URL || "http://192.168.1.181/SalaryMastersAPI/api";
const BASE_URL_SALARY = process.env.REACT_APP_API_URL_Salary_Transactionapi || "http://192.168.1.181/SalaryTransaction/api";

/* ================= CREATE AXIOS INSTANCES ================= */
export const axiosMaster = axios.create({
  baseURL: BASE_URL_MASTER,
  headers: { "Content-Type": "application/json" },
});

export const axiosSalary = axios.create({
  baseURL: BASE_URL_SALARY,
  headers: { "Content-Type": "application/json" },
});

/* ================= REQUEST & RESPONSE INTERCEPTORS ================= */
const setupInterceptors = (axiosInstance, baseURL) => {
  // Request interceptor to add token
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor to handle 401 errors
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem("refreshToken");
          if (!refreshToken) throw new Error("No refresh token");

          // Request new token using refresh token
          const res = await axios.post(`${baseURL}/Auth/refresh-token`, { refreshToken });
          const { token: newToken, refreshToken: newRefreshToken } = res.data;

          // Update localStorage
          localStorage.setItem("token", newToken);
          if (newRefreshToken) localStorage.setItem("refreshToken", newRefreshToken);

          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosInstance(originalRequest);
        } catch (err) {
          // If refresh fails, clear storage & redirect
          localStorage.clear();
          window.location.href = "/";
          return Promise.reject(err);
        }
      }

      return Promise.reject(error);
    }
  );
};

/* ================= APPLY INTERCEPTORS ================= */
setupInterceptors(axiosMaster, BASE_URL_MASTER);
setupInterceptors(axiosSalary, BASE_URL_SALARY);

/* ================= EXPORT FOR USE ================= */
// Usage:
// import { axiosMaster, axiosSalary } from './Services/axiosInstances';